"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConversionUtility_1 = require("./ConversionUtility");
exports.convertToInvoiceMetadataInput = ConversionUtility_1.convertToInvoiceMetadataInput; /*, convertToCreditNoteMetadataInput*/
var ApiUtility_1 = require("./ApiUtility");
exports.submitInvoice = ApiUtility_1.submitInvoice;
exports.submitDocument = ApiUtility_1.submitDocument;
